<div class="legal-container">
  <div class="legal-content">
    <h1>Politique de Confidentialité</h1>
    <p class="last-updated">Dernière mise à jour : {{ currentDate | date: 'dd/MM/yyyy' }}</p>

    <section>
      <h2>1. Introduction</h2>
      <p>
        La présente politique de confidentialité décrit comment nous collectons, utilisons et protégeons
        vos données personnelles lorsque vous utilisez notre plateforme.
      </p>
    </section>

    <section>
      <h2>2. Données collectées</h2>
      <p>Nous collectons les types de données suivantes :</p>
      <ul>
        <li>Adresse email</li>
        <li>Mot de passe (chiffré)</li>
        <li>Informations de connexion via GitHub (si applicable)</li>
        <li>Données d'utilisation de la plateforme</li>
      </ul>
    </section>

    <section>
      <h2>3. Utilisation des données</h2>
      <p>Vos données sont utilisées pour :</p>
      <ul>
        <li>Créer et gérer votre compte</li>
        <li>Sauvegarder vos projets et configurations</li>
        <li>Améliorer nos services</li>
        <li>Vous contacter concernant votre compte</li>
      </ul>
    </section>

    <section>
      <h2>4. Protection des données</h2>
      <p>
        Nous mettons en œuvre des mesures de sécurité appropriées pour protéger vos données contre
        tout accès non autorisé, modification, divulgation ou destruction.
      </p>
    </section>

    <section>
      <h2>5. Vos droits</h2>
      <p>Conformément au RGPD, vous disposez des droits suivants :</p>
      <ul>
        <li>Droit d'accès à vos données</li>
        <li>Droit de rectification</li>
        <li>Droit à l'effacement</li>
        <li>Droit à la portabilité</li>
        <li>Droit d'opposition</li>
      </ul>
    </section>

    <section>
      <h2>6. Cookies</h2>
      <p>
        Nous utilisons des cookies essentiels pour le fonctionnement de la plateforme,
        notamment pour maintenir votre session active.
      </p>
    </section>

    <section>
      <h2>7. Contact</h2>
      <p>
        Pour toute question concernant cette politique de confidentialité ou pour exercer vos droits,
        veuillez nous contacter à : <a href="mailto:contact@example.com">jade.jolivet&#64;gmail.com</a>
      </p>
    </section>
  </div>
</div>
